/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Scene_Atelier_DeliveryInputs */

const en_scene_atelier_delivery = /** @type {(inputs: Scene_Atelier_DeliveryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delivery`)
};

/**
* | output |
* | --- |
* | "Delivery" |
*
* @param {Scene_Atelier_DeliveryInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const scene_atelier_delivery = /** @type {((inputs?: Scene_Atelier_DeliveryInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Scene_Atelier_DeliveryInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_scene_atelier_delivery(inputs)
});